// extracted by mini-css-extract-plugin
export var arrowUpAndDown = "Classification-module--arrow-up-and-down--47e37";
export var fiveStarFill = "Classification-module--fiveStarFill--10003";
export var fourStarFill = "Classification-module--fourStarFill--eef8d";
export var oneStarFill = "Classification-module--oneStarFill--1bfcc";
export var rating = "Classification-module--rating--59db0";
export var ratingTitle = "Classification-module--ratingTitle--293d7";
export var star = "Classification-module--star--77848";
export var starContainer = "Classification-module--starContainer--17696";
export var threeStarFill = "Classification-module--threeStarFill--0373b";
export var twoStarFill = "Classification-module--twoStarFill--137cb";
export var withSpaceAround = "Classification-module--withSpaceAround--0804f";